export default "__VITE_ASSET__1XaQCoiA__"